<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="goBack"
              >keyboard_arrow_left</span
            >
            <span class="title-text" @click="goBack"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4 justify-content-center">
      <div class="col-lg-9 py-2">
        <div class="pt-3" v-if="trackingOrder">
          <div class="row" v-if="displayModel.status != 4 || isDoorDash">
            <div class="col-sm-12 text-center">
              <h2 v-if="!displayModel.isPayLater && showNewUi"  class="fw-normal badge badge-secondary bg-success mt-4 p-3" style="border-radius: 50px">
                {{ displayModel.orderState }}
              </h2>
              <h1  v-else-if="!displayModel.isPayLater && !showNewUi" class="fw-normal">
                {{ displayModel.orderState }}
              </h1>
              <div
                class="alert alert-primary"
                role="alert"
                v-if="createUserForGuest"
              >
                <span>{{ $t("message.emailConfirmation") }}.</span>
              </div>
            </div>
          </div>
          <div class="row" v-show="false">
            <div class="col-sm-12 text-center dtime color-gray">
              <span class="material-icons color-light-gray">query_builder</span>
              <span>
                {{ displayModel.orderMode }} in approximately {{ minutes }}mins
              </span>
            </div>
          </div>
          <div
            class="row"
            v-if="
              !isTwoColumn &&
              displayModel.status > -1 &&
              displayModel.status < 5
            "
          >
            <div
              v-if="displayModel.status < 4 || isDoorDash"
              class="col-sm-12 d-flex justify-content-center multi-steps-wrapper"
            >
              <ul
                class="list-unstyled cstepper"
                :class="{ doordash: isDoorDash }"
              >
                <li>
                  <div
                    class="node gray"
                    :class="{
                      activated:
                        (displayModel.status > 0 && displayModel.status <= 4) ||
                        this.dStatus > 0,
                    }"
                  ></div>
                  <p :class="showNewUi && 'pending'">{{ $t("message.pending") }}</p>
                </li>
                <li>
                  <div
                    class="divider"
                    :class="[
                      (displayModel.status > 0 && displayModel.status < 3) ||
                      displayModel.status === 4 ||
                      this.dStatus > 0
                        ? 'black'
                        : 'gray',
                    ]"
                  ></div>
                </li>
                <li>
                  <div
                    class="node gray"
                    :class="{
                      activated:
                        (displayModel.status > 0 && displayModel.status < 3) ||
                        displayModel.status == 4 ||
                        this.dStatus > 0,
                    }"
                  ></div>
                  <p :class="showNewUi && 'preparing'">{{ $t("message.preparing") }}</p>
                </li>
                <li>
                  <div
                    class="divider"
                    :class="[
                      displayModel.status === 2 ||
                      displayModel.status === 4 ||
                      this.dStatus > 0
                        ? 'black'
                        : 'gray',
                    ]"
                  ></div>
                </li>
                <li>
                  <div
                    class="node gray"
                    :class="{
                      activated:
                        displayModel.status === 2 ||
                        displayModel.status == 4 ||
                        (this.isTwoColumn && displayModel.status == 1) ||
                        this.dStatus > 0,
                    }"
                  ></div>
                  <p v-if="isDoorDash">{{ $t("message.readyForDelivery") }}</p>
                  <p
                    v-else-if="
                      trackingOrder.OrderType === 10 ||
                      trackingOrder.OrderType === 2
                    "
                  >
                    {{ $t("message.onItsWay") }}
                  </p>
                  <p v-else>{{ $t("message.readyForPickup") }}</p>
                </li>
                <li v-if="isDoorDash">
                  <div
                    class="divider"
                    :class="[this.dStatus > 0 ? 'black' : 'gray']"
                  ></div>
                </li>
                <!-- doordash -->
                <li v-if="isDoorDash">
                  <div
                    class="node gray"
                    :class="{
                      activated: this.dStatus > 0,
                    }"
                  ></div>
                  <p>{{ $t("message.pickedUp") }}</p>
                </li>
                <li v-if="isDoorDash">
                  <div
                    class="divider"
                    :class="[this.dStatus >= 2 ? 'black' : 'gray']"
                  ></div>
                </li>
                <li v-if="isDoorDash">
                  <div
                    class="node gray"
                    :class="{
                      activated: this.dStatus >= 2,
                    }"
                  ></div>
                  <p>{{ $t("message.enRoute") }}</p>
                </li>
                <li v-if="isDoorDash">
                  <div
                    class="divider"
                    :class="[this.dStatus > 2 ? 'black' : 'gray']"
                  ></div>
                </li>
                <li v-if="isDoorDash">
                  <div
                    class="node gray"
                    :class="{
                      activated: this.dStatus == 3,
                    }"
                  ></div>
                  <p>{{ $t("message.droppedUp") }}</p>
                </li>
              </ul>
            </div>
            <h2 class="w-100 text-center" v-else-if="displayModel.status == 4">
              {{ $t("message.orderCompleted") }}
            </h2>
            <h2 class="w-100 text-center" v-else-if="displayModel.status == 5">
              {{ $t("message.orderRefunded") }}
            </h2>
          </div>
          <div
            v-else-if="
              isTwoColumn && displayModel.status > -1 && displayModel.status < 5
            "
          >
            <h2
              class="text-center"
              v-if="displayModel.status == 0 && displayModel.status == 3"
            >
              {{ $t("message.pending") }}
            </h2>
            <h2
              class="text-center"
              v-if="
                displayModel.status > 0 &&
                updateDisplayModel.status < 5 &&
                displayModel.status != 3
              "
            >
              {{ $t("message.orderAccepted") }}
            </h2>
            <h2 class="text-center" v-if="displayModel.status == 5">
              {{ $t("message.orderRefunded") }}
            </h2>
          </div>
          <div v-else-if="displayModel.status < 0" class="row">
            <div class="col-sm-12 text-center d-flex justify-content-center">
              <div
                v-if="displayModel.status == -1 || displayModel.status == -3"
                class="text-danger text-size-9 px-5"
              >
                <div v-if="isOrderFailed">
                  <p>
                    <span v-if="displayModel.orderState">{{displayModel.orderState}}</span>
                    <span v-else >{{ $t("message.orderFaildMessageLine1") }}.</span>
                    <br />
                    {{ gerOrderFaildLine2Message }}.
                    <br />
                    <span>{{ $t("message.orderFaildMessageLine3") }}.</span>
                  </p>
                </div>
                <div v-else>
                  <p>
                    {{ $t("message.yourOrderHasBeenRejected") }}
                    <br />
                    {{ trackingOrder.OnlineOrderStatusDescription }}
                    <br />
                    {{ $t("message.YourPaymentWillBeRefunded") }}
                  </p>
                </div>
              </div>
              <div
                v-else-if="displayModel.status == -2"
                class="text-danger text-size-9 px-5"
              >
                <div>
                  <p>
                    {{ $t("message.paymentFaildMessageLine1") }}.
                    <br />
                    {{ $t("message.paymentFaildMessageLine2") }}.
                    <br />
                    {{ $t("message.paymentFaildMessageLine3") }}.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 text-center d-flex justify-content-center">
              <div class="storeInfo">
                <router-link v-if="false" class="text-primary pr-2" to="#">
                  {{ $t("message.pickUpFrom") }}
                </router-link>
                <div>{{ store.Name }}</div>
                <div v-if="store.Location">{{ store.Location.Address }}</div>
                <div v-if="store.Location">
                  {{ store.Location.Suburb }} {{ store.Location.State }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="displayModel.status >= 0"
            class="row justify-content-center mt-3 font-weight-bold"
          >
            {{ trackingOrder.OrderNumber ? "#" : ""
            }}{{ trackingOrder.OrderNumber }}
          </div>
          <div
            class="row justify-content-center mt-2 mx-2 text-center"
            v-if="
              displayModel.status >= 0 &&
              displayModel.status <= 4 &&
              !displayModel.isPayLater &&
              isDelivery()
            "
          >
            <h5>
              {{ estimatedPickupDeliveryTimeLabel }} :
              <br />
              {{ estimeatedTimeText }}
            </h5>
          </div>
          <div class="row order-history-div">
            <div class="col-sm-12 text-center">
              <button
                v-show="displayModel.status < 0"
                type="button"
                class="btn btn-primery pr-2 btn-with-margins"
                @click="backToCheckout"
                :style="mobileStyles.btn"
              >
                {{
                  displayModel.status === -2
                    ? $t("message.ReEnterPayment")
                    : $t("message.retry")
                }}
              </button>
              <button
                v-show="user"
                type="button"
                class="btn btn-primery pr-2 btn-with-margins"
                @click="viewHistory"
                :style="getMobileStyles"
              >
                {{ $t("message.viewMyOrderHistory") }}
              </button>
              <br />
              <button
                type="button"
                class="btn btn-info btn-with-margins"
                :class="!showNewUi && 'pr-2'"
                @click="continueShopping"
                :style="getMobileStyles"
              >
                {{ $t("message.continueOrdering") }}
              </button>
              <button
                type="button"
                class="btn btn-info btn-with-margins"
                :class="!showNewUi && 'pr-2'"
                @click="viewOrder"
                :style="getMobileStyles"
                v-if="storeTable && payTableEnabled"
              >
                {{ $t("message.viewOrder") }}
              </button>
              <poweredby />
            </div>a
          </div>
        </div>
        <progressindicator v-else style="opacity: 0.4"></progressindicator>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../../sharedscripts/shop/Checkout/CompleteOrder.js";
import poweredby from "../../shared/poweredby";
import { interpolate } from "../../../api/helpers/stringHelper";
import Progressindicator from "../../progressindicator";
export default {
  components: {
    poweredby,
    Progressindicator,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
    orderid: {
      type: String,
      default: "",
    },
    userid: {
      type: String,
      default: "",
    },
    createUserForGuest: {
      type: Boolean,
      default: false,
    },
    selectedCompanyId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      store: {},
      trackingOrder: null,
      minutes: 0,
      displayModel: {
        orderMode: "Pickup",
        orderState: "Order Sent!",
        status: 10,
        isPayLater: false,
      },
    };
  },
  computed: {
    ...mapGetters(["user", "mobileStyles"]),
    ...shared.computed,
    gerOrderFaildLine2Message() {
      return interpolate(
        this.$t("message.orderFaildMessageLine2"),
        this.store.Name,
        this.store.OfficePhone
      );
    },
    getMobileStyles() {
      const style = []
      style.push(this.mobileStyles.btn)
      style.push({
        borderRadius: "5px",
      })
      return style
    },
  },
  watch: {
    ...shared.watch,
  },
  beforeDestroy() {
    this.beforeDestroyComponent();
  },
  created() {
    this.createdComponent();
  },
  methods: {
    ...shared.methods,
    goBack() {
      this.$router.push({
        name: "store",
        params: { storeid: this.storeid },
      });
    }
  },
};
</script>
